import { useState, forwardRef, useEffect } from "react";
import { TextField, Grid, InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  JOrder,
  resetForm,
  setAdminDiscountDialog,
} from "../../../../app/slices/jomla/orderSlice";
import { NumericFormat } from "react-number-format";
import { HiOutlineReceiptPercent, HiOutlineCalculator } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const EditAdminDiscountForm = () => {
  const dispatch = useDispatch();

  const _JOrder = useSelector((state) => state.jOrder.adminDiscount);
  // const _SearchBody = useSelector((state) => state.jOrder.searchBody);
  const [loading, setLoading] = useState(false);

  const { control, reset, handleSubmit, setValue, } = useForm({
    defaultValues: _JOrder.form,
  });

  const onSubmit = (data) => {
    setLoading(true);
    dispatch(
      JOrder.editAdminDiscount(
        _JOrder.form.id,
        {
          admin_discount: data.admin_discount ?? 0,
        },
        'orderDetails'
      )
    )
      .then((x) => setLoading(false))
      .catch((e) => setLoading(false));
  };

  useEffect(() => {
    reset({ ..._JOrder.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_JOrder.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialog = () => {
    dispatch(setAdminDiscountDialog(0))
  };

  const NumericFormatCustom = forwardRef(function NumericFormatCustom(
    props,
    ref
  ) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: parseInt(values.value),
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  });

  return (
    <FormDialog
      open={_JOrder.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineReceiptPercent />}
      title={"تعديل الخصم "}
      subtitle="قم بتحديث خصم الطلب ثم احفظ التغييرات"
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
      loading={_JOrder.loading}
    >
      <SectionCard icon={<HiOutlineCalculator />} title="الخصم">
        <Grid item xs={12} sm={6}>
          <Controller
            control={control}
            name={"admin_discount_percent"}
            render={({ field }) => (
              <TextField
                size="small"
                label="نسبة الخصم"
                fullWidth
                {...field}
                onChange={(e) => {
                  setValue('admin_discount', (e.target.value / 100) * _JOrder.form.amount)
                  field.onChange(e);
                }}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">%</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            control={control}
            name={"admin_discount"}
            render={({ field }) => (
              <TextField
                size="small"
                label="الخصم"
                fullWidth
                {...field}
                onChange={(e) => {
                  setValue('admin_discount_percent', (e.target.value / _JOrder.form.amount) * 100)
                  field.onChange(e);
                }}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default EditAdminDiscountForm;
